
<mat-card>
    <mat-card-header>
      <mat-card-title>Thank you for contacting us.</mat-card-title>
    </mat-card-header>
<mat-card-content class="m-t-1">
    <p>We will contact you as soon as we have reviewed your information.<br>Please know that all information received will remain secure and confidential.<br>If this is an urgent matter, please contact us directly.</p>
</mat-card-content>
</mat-card>